<div class="header-sort" (click)="onClickDirection()">
  <span>{{ description }}</span>
  <span *ngIf="column !== ''">
    <i *ngIf="direction === 'asc'" class="fa fa-arrow-down"></i>
    <i *ngIf="direction === 'desc'" class="fa fa-arrow-up"></i>
  </span>
</div>
